var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifyok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.white{fill:#FFFFFF;}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fill: "#fff",
    className: "white",
    d: "M15.42,28.86c-0.59-0.51-1.24-0.94-1.95-1.27c-1.86-0.7-2.8-2.76-2.1-4.62 c0.14-0.38,0.35-0.74,0.61-1.05c0.74-1.66,2.48-2.63,4.27-2.38c0.99,0.15,1.91,0.57,2.67,1.21c0.43,0.35,0.69,0.37,0.99-0.13 c0.23-0.35,0.49-0.68,0.76-0.99c-1.22-0.71-2.5-1.29-3.83-1.75c-1.01-0.3-1.6-1.36-1.3-2.37c0.09-0.3,0.24-0.57,0.46-0.79 c2.02-2.48,2.97-5.66,2.65-8.84c-0.12-3.32-2.87-5.94-6.2-5.88c-3.32-0.1-6.1,2.49-6.25,5.81c-0.35,3.24,0.63,6.48,2.72,8.98 c0.67,0.79,0.56,1.97-0.23,2.64c-0.19,0.16-0.4,0.28-0.64,0.35c-1.95,0.7-3.79,1.67-5.46,2.89c-1.34,0.78-2.19,2.19-2.25,3.74 c-0.05,1.23,0.64,2.36,1.75,2.89c1.52,0.73,3.17,1.18,4.85,1.31C9.76,28.89,12.59,28.98,15.42,28.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fill: "#fff",
    className: "white",
    d: "M29.66,16.14c-4.25,1.63-7.76,4.78-9.84,8.83c-0.72-1.04-1.63-1.94-2.68-2.66 c-0.98-0.76-2.4-0.57-3.15,0.41c-0.29,0.38-0.45,0.83-0.46,1.3c-0.13,0.54,0.14,1.09,0.65,1.3c1.96,0.87,3.62,2.29,4.78,4.09 c0.55,0.84,1.4,0.73,1.84-0.19c0.76-1.58,1.42-3.19,2.2-4.75c1.47-2.93,3.54-5.52,6.07-7.61c0.17-0.15,0.35-0.31,0.52-0.47 C29.61,16.38,29.61,16.32,29.66,16.14"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyok);
export default __webpack_public_path__ + "static/media/verifyok.8209466b7c9196faecdfff9cf2d8bfc8.svg";
export { ForwardRef as ReactComponent };